export default __webpack_public_path__ + "static/media/wolf.88c3be25.jpg";